import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
export function ComparisonSection() {
  return <section id="elegir" className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto scroll-mt-20" data-id="element-24">
      <div className="text-center mb-10 sm:mb-14" data-id="element-25">
        <p className="text-base sm:text-lg text-brand-text/80 font-medium mb-4" data-id="element-26">
          Todo lo que necesitás en un solo lugar
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-brand-text font-bold leading-tight" data-id="element-27">
          Llevate el Mega Kit Completo
        </h2>
      </div>

      <div className="flex justify-center items-stretch" data-id="element-28">
        {/* Mega Kit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-card rounded-[2rem] p-6 sm:p-8 border-4 border-brand-cta shadow-2xl flex flex-col relative w-full max-w-lg" data-id="element-29">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-cta-hover text-white px-6 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider flex items-center gap-2 shadow-md whitespace-nowrap" data-id="element-30">
            <Star className="w-4 h-4 fill-white" data-id="element-31" />
            OFERTA ÚNICA
          </div>

          <div className="text-center mb-6 mt-4" data-id="element-32">
            <h3 className="text-3xl sm:text-4xl font-serif font-bold text-brand-cta mb-2" data-id="element-33">
              DECO TRICOTÍN
            </h3>
            <p className="text-brand-text/80 font-medium text-lg" data-id="element-34">
              Mega Kit Completo
            </p>
          </div>

          <ul className="space-y-4 mb-8 flex-grow" data-id="element-35">
            {['Guía paso a paso + videos', '+300 plantillas listas para usar', 'Todos los packs temáticos incluidos', 'Mini guías de llaveros y lapiceras', 'Ideas de decoración y souvenirs', 'Guía de emprendimiento'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text" data-id="element-36">
                <CheckCircle2 className="w-5 h-5 text-brand-cta shrink-0 mt-0.5" data-id="element-37" />
                <span className="font-medium" data-id="element-38">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mt-auto bg-brand-warm/30 rounded-2xl p-4 sm:p-6 border border-brand-warm" data-id="element-39">
            <p className="text-brand-cta font-bold text-xl sm:text-2xl mb-4 font-serif" data-id="element-40">
              LLEVATE TODO POR SOLO
            </p>
            <div className="flex flex-col items-center gap-1 mb-6" data-id="element-41">
              <span className="text-5xl sm:text-6xl font-bold text-brand-text font-serif leading-none" data-id="element-42">
                $24.990
              </span>
            </div>

            <a href="https://pago.atlasdigitalhub.com/cart/42976083411042:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 rounded-full bg-brand-cta text-white font-bold text-lg uppercase tracking-wider hover:bg-brand-cta/90 transition-colors duration-300 shadow-xl text-center" data-id="element-43">
              QUIERO MI KIT COMPLETO
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}